import { css } from '@emotion/react'
import styled from '@emotion/styled'
import styles from '@mathflat/common/style'

const {
  colors: { primary, gray, borderColor },
} = styles

/**
 * @deprecated 디자인시스템의 createCheckbox를 사용하세요.
 */
const S = {
  checkedLabel: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: 1px solid ${gray.$500};
    border-radius: var(--Radius-100);
    background-color: white;
    cursor: pointer;
  `,
}

/**
 * @deprecated 디자인시스템의 createCheckbox를 사용하세요.
 */
const CheckBoxWrap = styled.label`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  align-self: center;

  &.disabled,
  &.disabled label {
    cursor: default !important;
  }

  &:hover,
  &:focus {
    .checkbox_label {
      border-color: ${primary};
    }
  }

  input[type='checkbox'][data-indeterminate='true'] + label {
    background: var(--Colors-Green-100);
    border-color: ${primary};
    :after {
      border-color: transparent;
    }
  }

  input[type='checkbox'] {
    background-color: ${primary};
    &[data-indeterminate='true'] + .checkbox_label {
      background: var(--Colors-Green-100);
      border-color: var(--Colors-Green-200);
      :after {
        border-color: transparent;
      }
    }
    &:checked + .checkbox_label {
      border: 1px solid ${primary};
      background-color: ${primary};
      :after {
        display: block;
        position: absolute;
        width: 10px;
        height: 4px;
        border-left: 2px solid;
        border-bottom: 2px solid;
        margin-top: -2px;
        content: '';
        transform: rotate(-45deg);
        border-color: white;
      }
    }
    &:disabled + .checkbox_label {
      border: 1px solid ${borderColor};
      background-color: ${gray.$200};
      &:after {
        border-color: ${gray.$200};
      }
    }
    &[disabled]:checked + .checkbox_label {
      &:after {
        border-color: ${gray.$470};
      }
    }
  }
  input {
    display: none;
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    opacity: 0;
    z-index: -1;
  }

  .with-text {
    display: flex;
    align-items: center;
    margin-left: 12px;
    height: 20px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &.disabled {
      color: ${gray.$500};
    }
  }
`

export { CheckBoxWrap }
export default S
